<template>
  <div class="relative flex items-center">
    <button
      type="button"
      class="text-xl flex items-center pr-3 cursor-pointer bg-transparent border-none"
      @click="toggle"
      aria-label="Notifications"
    >
      <i class="fa-solid fa-bell"></i>
      <Badge
        v-if="notificationStore.hasUnread"
        :value="notificationStore.unreadCount"
        severity="danger"
        class="absolute -top-2 right-0"
        size="small"
      />
    </button>

    <Popover ref="op" dismissable>
      <NotificationDropdown @close="hide" />
    </Popover>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import Badge from 'primevue/badge';
import Popover from 'primevue/popover';
import NotificationDropdown from './NotificationDropdown.vue';
import { useNotificationStore } from '@/stores/notification';

const notificationStore = useNotificationStore();
const op = ref();

const toggle = (event) => {
  op.value.toggle(event);
};

const hide = () => {
  op.value.hide();
};
</script>
